export class ApiModel {
    ID: string;
    client_ID: string;
    assignee: string;
    user_ID: string;
    user_firstname: string;
    user_lastname: string;
    datetime_created: string;
    datetime_created_from: string;
    datetime_created_to: string;
    datetime_modified: string;
    datetime_modified_from: string;
    datetime_modified_to: string;
    json_custom_fields: string;
    custom_fields: any;
    error: any;
}


export class SfBiDashboard {
    Name: string;
    Description: string;
    Id: string;
    Version: string;
    IsPublic: boolean;
    ItemLocation: string;
    CategoryName: string;
}

export class Project {
    project: any;
}

export class ProjectHolder {
    id: number;
    project: Project;
    config: ProjectConfig;
}

export class ProjectConfig {
    ConditionCollections: any;
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/model.model.ts